export const RESET_PASSWORD_PAGE_TITLE = 'reset-password-page.title';
export const RESET_PASSWORD_PAGE_DESCRIPTION = 'reset-password-page.description';
export const RESET_PASSWORD_PAGE_ICON_ALT = 'reset-password-page.icon-alt';
